import { useEffect, useState } from 'react';
import { useFetchCallback } from '@services/services';
import toast from 'react-hot-toast';
import { Announcement } from '@interfaces/general';

interface ActiveAnnouncementsResponse {
  data: Announcement[];
  plan: string;
}

export const useGetAnnouncement = () => {
  const [announcements, setAnnouncements] = useState<Announcement[]>([]);
  const [plan, setPlan] = useState<string>('');

  const { isFetching, call } = useFetchCallback<undefined, ActiveAnnouncementsResponse>(
    'get',
    '/v1/announcement/active',
  );

  const fetchAnnouncements = async () => {
    try {
      const response = await call({});
      if (response) {
        // Defensa front: el back deberia excluir anuncios ya respondidos cuando
        // show_once=true, pero hoy los sigue devolviendo con user_response
        // poblado. Sin este filtro la card/banner/modal vuelve a aparecer en
        // cada sesion aunque el comercio ya haya votado.
        // Segunda capa: si el usuario dismissó sin opción (X / CTA) se persiste
        // en localStorage via persistDismissLocally en useRespondAnnouncement.
        const locallyDismissed: string[] = JSON.parse(localStorage.getItem('plick_dismissed_show_once') ?? '[]');
        const visible = (response.data ?? []).filter((a) => {
          if (a.show_once && a.user_response !== null) return false;
          if (a.show_once && locallyDismissed.includes(a.uuid)) return false;
          return true;
        });
        setAnnouncements(visible);
        setPlan(response.plan || '');
      }
    } catch {
      toast.error('Error al obtener los anuncios');
    }
  };

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  return {
    announcements,
    plan,
    isFetching,
    refetch: fetchAnnouncements,
  };
};
